module.exports = __webpack_public_path__ + "static/media/avocado.a8c9910a.png";